import { generatorDerivativeColors, getColorFromOriginColor as gc, } from "../../interface/color";
import { syntheticColors } from "../../utils/synthetic-colors";
import tinycolor from "tinycolor2";
/** 主黑 */
export const defaultMainBlackColor = [
    "#f7fafa",
    "#f2f5f5",
    "#e8ebeb",
    "#d9dcdc",
    "#bfc4c5",
    "#8c9596",
    "#4c5a5c",
    "#192b2e",
    "#001417",
    "#979797",
];
/** 主黑透明 */
export const defaultMainBlackTransparentColor = [
    "rgba(0, 34, 38, 0.02)",
    "rgba(0, 34, 38, 0.04)",
    "rgba(0, 34, 38, 0.09)",
    "rgba(0, 20, 23, 0.15)",
    "rgba(0, 20, 23, 0.25)",
    "rgba(0, 20, 23, 0.45)",
    "rgba(0, 20, 23, 0.7)",
    "rgba(0, 20, 23, 0.9)",
    "rgba(0, 20, 23, 1)",
];
/** 白 */
export const defaultWhiteColor = [
    "rgba(255, 255, 255, 0.04)",
    "rgba(255, 255, 255, 0.09)",
    "rgba(255, 255, 255, 0.15)",
    "rgba(255, 255, 255, 0.25)",
    "rgba(255, 255, 255, 0.45)",
    "rgba(255, 255, 255, 0.65)",
    "rgba(255, 255, 255, 0.85)",
    "rgba(255, 255, 255, 0.97)",
    "rgba(255, 255, 255, 1)",
];
/** 黑 */
export const defaultBlackColor = [
    "rgba(0, 0, 0, 0.02)",
    "rgba(0, 0, 0, 0.04)",
    "rgba(0, 0, 0, 0.09)",
    "rgba(0, 0, 0, 0.15)",
    "rgba(0, 0, 0, 0.25)",
    "rgba(0, 0, 0, 0.45)",
    "rgba(0, 0, 0, 0.65)",
    "rgba(0, 0, 0, 0.85)",
    "rgba(0, 0, 0, 1)",
];
/** 中性色 */
export const defaultNeutralColor = [
    "rgb(250, 250, 250)",
    "rgb(245, 245, 245)",
    "rgb(232, 232, 232)",
    "rgb(217, 217, 217)",
    "rgb(191, 191, 191)",
    "rgb(140, 140, 140)",
    "rgb(89, 89, 89)",
    "rgb(38, 38, 38)",
];
/** 阴影 */
export const defaultShadow = [
    "0px 1px 4px 0px rgba(0,0,0,0.25)",
    "0px 2px 8px 0px rgba(0,0,0,0.25)",
    "0px 3px 14px 2px rgba(0,0,0,0.25)",
    "0px 4px 20px 2px rgba(0,0,0,0.25)",
    "0px 6px 20px 6px rgba(0,0,0,0.25)",
    "0px 3px 8px 0px rgba(0,0,0,0.45)",
    "0px 4px 17px 3px rgba(0,0,0,0.45)",
    "0px 8px 28px 3px rgba(0,0,0,0.45)",
];
/** 色板1 */
export const globalColorPalette1 = {
    mainColor: [
        "#eafcfc",
        "#d8f7f6",
        "#6cdee0",
        "#44ccd4",
        "#20b9c7",
        "#009aaf",
        "#00839a",
        "#005c70",
        "#003e51",
        "#002c3b",
    ],
    secondaryColor: [
        "#f0f2f7",
        "#d9deef",
        "#b9c3e1",
        "#99a0c7",
        "#727aba",
        "#4d55ad",
        "#363a87",
        "#222361",
        "#12123b",
        "#070614",
    ],
    successColor: generatorDerivativeColors("#4ab98b"),
    errorColor: generatorDerivativeColors("#e34469"),
    warningColor: generatorDerivativeColors("#ffc53f"),
    mainBlackColor: defaultMainBlackColor,
    mainBlackTransparentColor: defaultMainBlackTransparentColor,
    mainGradientColor: ["#009aaf", "red", "#002c3b", "red"],
    secondaryGradientColor: ["linear-gradient(to bottom, red, green)", "red", "red", "red"],
    blackColor: defaultBlackColor,
    whiteColor: defaultWhiteColor,
    neutralColor: defaultNeutralColor,
    shadow: defaultShadow,
    subColor: [
        gc(6, 2),
        gc(6, 3),
        gc(6, 4),
        gc(6, 5),
        gc(6, 6),
        gc(6, 7),
        gc(6, 8),
        gc(6, 9),
        gc(6, 10),
        gc(6, 11),
        gc(6, 12),
        gc(6, 13),
        gc(6, 0),
        gc(6, 1),
        gc(8, 2),
        gc(8, 3),
        gc(8, 4),
        gc(8, 5),
        gc(8, 6),
        gc(8, 7),
        gc(8, 8),
        gc(8, 9),
        gc(8, 10),
        gc(8, 11),
        gc(8, 12),
        gc(8, 13),
        gc(8, 0),
        gc(8, 1),
    ],
};
/** 图表样式
 * @author James Zhang
 */
export const chartStyle = {
    mainTextColor: globalColorPalette1.mainColor[3],
    mainTextSize: 12,
    mainAxisColor: syntheticColors("#031220", getTransparentColor(globalColorPalette1.mainColor[2], 4)),
    secondaryTextColor: globalColorPalette1.mainColor[4],
    secondaryTextSize: 12,
    secondaryAxisColor: "transparent",
    splitLineColor: getTransparentColor(globalColorPalette1.mainColor[2], 3),
    tooltipMainTextColor: globalColorPalette1.mainColor[1],
    tooltipSecondaryTextColor: globalColorPalette1.mainColor[3],
};
/** 获取颜色的9阶透明度的颜色
 *
 * 一般用于生成透明系颜色
 * @author James Zhang
 */
export function getTransparentColors(color) {
    return [
        getTransparentColor(color, 0),
        getTransparentColor(color, 1),
        getTransparentColor(color, 2),
        getTransparentColor(color, 3),
        getTransparentColor(color, 4),
        getTransparentColor(color, 5),
        getTransparentColor(color, 6),
        getTransparentColor(color, 7),
        getTransparentColor(color, 8),
    ];
}
/**
 * 获透明颜色
 * @param index 颜色透明度对应的序号
 *
 * 透明度:`[0.02, 0.04, 0.09, 0.15, 0.25, 0.45, 0.7, 0.9, 1]`
 *
 * 序号数:`[0000, 0001, 0002, 0003, 0004, 0005, 006, 007, 8]`
 *
 * @author James Zhang
 *
 */
export function getTransparentColor(color, index) {
    return tinycolor(color).setAlpha([0.02, 0.04, 0.09, 0.15, 0.25, 0.45, 0.7, 0.9, 1][index]).toRgbString();
}
//# sourceMappingURL=index.js.map